import styled from "styled-components";

export const EmptyMessage = styled.p`
  padding: 40px 0;
  font-size: 16px;
  color: #555;
  text-align: center;
`;
